import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Auth, Warehouse } from 'services/action';

import _ from 'underscore';
import MenuRoute from './menu.route';

const MenuMaster = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const location = useLocation();
  const session = useSelector((state) => state?.Auth?.session);
  const sessionWarehouse = useSelector((state) => state?.Auth?.warehouse);
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse)
  const [warehouses, setWarehouses] = React.useState(null);

  const { pathname } = location;
  const splitLocation = pathname.split('/');

  const $getWarehouse = async () => {
    const req = await Dispatch(Warehouse.$get({"order_by": "id"}));

    if (req?.message === 'success' && req?.data) {
      if (!selectedWarehouse) {
        const p = _.first(req?.data);
        Dispatch(Auth.$warehouse(p));
      }

      setWarehouses(req?.data);
    }
  };

  const $handleWarehouseChange = async (e) => {
    Dispatch(Auth.$warehouse(e, true));

    setTimeout(function(){
      window.location.reload();
    }, 1500);
  };

  React.useEffect(() => {
    console.log(session)
    if (!sessionWarehouse) {
      $getWarehouse();
    }
  }, []);

  console.log(selectedWarehouse, '--------------------')

  return (
    <div className="nav-item d-none d-md-block">
      <ul className="navbar-nav">
        {!sessionWarehouse && (
          <li className="nav-item me-2">
            <Nav>
              <NavDropdown
                menuVariant="secondary"
                className="bg-white m-0 p-0 rounded-3 carret-dark"
                style={{
                  minWidth: 150,
                }}
                title={
                  <div
                    className="text-dark text-start text-uppercase fw-bold"
                    style={{ fontSize: 13, marginBottom: 0 }}
                  >
                    {selectedWarehouse?.name}
                  </div>
                }
              >
                {warehouses?.map((d, i) => (
                  <NavDropdown.Item
                    key={i}
                    onClick={() => $handleWarehouseChange(d)}
                  >
                    {d?.name}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </Nav>
          </li>

        )}

        {MenuRoute.map((menu, index) => {
          let link = null;

          if (menu?.isMaster) {
            if (session?.privileges) {
              let child = [];
              let privileges = session?.privileges?.map((h) => h?.service);

              menu?.service?.forEach((g) => {
                if (privileges?.includes(g)) {
                  child?.push(g);
                }
              });

              let path = '';

              let client = _.findWhere(session?.privileges, {
                service: 'nvo.platform.client',
                action: 'manage',
              });

              let service = _.findWhere(session?.privileges, {
                service: 'nvo.tms.service',
              });

              let pricing = _.findWhere(session?.privileges, {
                service: 'nvo.tms.pricing',
              });

              let hub = _.findWhere(session?.privileges, {
                service: 'nvo.platform.location.hub',
              });

              let usergroup = _.findWhere(session?.privileges, {
                service: 'nvo.platform.usergroup',
                action: 'manage',
              });

              let user = _.findWhere(session?.privileges, {
                service: 'nvo.platform.user',
              });

              if (client) {
                path = '/setting';
              } else if (service) {
                path = '/setting/service';
              } else if (pricing) {
                path = '/setting/pricing';
              } else if (hub) {
                path = '/setting/hub';
              } else if (usergroup) {
                path = '/setting/usergroup';
              } else if (user) {
                path = '/setting/user';
              }

              if (child?.length > 0) {
                link = !menu?.isDropdown ? (
                  <li key={index} className="nav-item">
                    <NavLink
                      to={path}
                      className="nav-link"
                      activeClassName="active"
                      isActive={(match, location) => {
                        const splitLocation = location.pathname.split('/');
                        if (splitLocation[1] === menu.isActive) {
                          return true;
                        }
                      }}
                    >
                      <div className="d-flex justify-content-center align-items-center">
                        <span
                          className="nav-link-icon d-inline-block m-0"
                          style={{
                            width: 'auto',
                            height: 'auto',
                          }}
                        >
                          {menu.icon}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                ) : (
                  <li key={index} className="nav-item">
                    <Nav>
                      <NavDropdown
                        active={splitLocation[1] === menu?.isActive}
                        menuVariant="dark"
                        className="no-carret"
                        title={
                          <div className="d-flex justify-content-center align-items-center m-0">
                            <span
                              className="nav-link-icon d-inline-block m-0"
                              style={{
                                width: 'auto',
                                height: 'auto',
                              }}
                            >
                              {menu.icon}
                            </span>
                          </div>
                        }
                      >
                        {menu?.child.map((c, index) => {
                          let menu = null;
                          let x = _.findWhere(session?.privileges, {
                            service: c?.service,
                          });

                          if (x) {
                            if (c?.action?.includes(x?.action)) {
                              menu = (
                                <NavDropdown.Item
                                  key={index}
                                  onClick={() => History.push(c?.path)}
                                  active={splitLocation[1] === c?.isActive}
                                >
                                  {c?.title}
                                </NavDropdown.Item>
                              );
                            }
                          }
                          return menu;
                        })}
                      </NavDropdown>
                    </Nav>
                  </li>
                );
              }
            } else {
              link = menu.isMaster ? (
                <li key={index} className="nav-item">
                  {!menu?.isDropdown ? (
                    <NavLink
                      to={menu.path}
                      className="nav-link"
                      activeClassName="active"
                      isActive={(match, location) => {
                        const splitLocation = location.pathname.split('/');

                        if (splitLocation[1] === menu.isActive) {
                          return true;
                        }

                        if (
                          menu.isActive === 'user_management' &&
                          splitLocation[2] === 'management'
                        ) {
                          return true;
                        }
                      }}
                    >
                      <div className="d-flex justify-content-center align-items-center">
                        <span
                          className="nav-link-icon d-md-none d-lg-inline-block m-0"
                          style={{
                            width: 'auto',
                            height: 'auto',
                          }}
                        >
                          {menu.icon}
                        </span>
                      </div>
                    </NavLink>
                  ) : (
                    <Nav>
                      <NavDropdown
                        active={splitLocation[1] === menu?.isActive}
                        menuVariant="dark"
                        className="no-carret"
                        title={
                          <div className="d-flex justify-content-center align-items-center m-0">
                            <span
                              className="nav-link-icon d-inline-block m-0"
                              style={{
                                width: 'auto',
                                height: 'auto',
                              }}
                            >
                              {menu.icon}
                            </span>
                          </div>
                        }
                      >
                        {menu?.child.map((c, index) => {
                          return (
                            <NavDropdown.Item
                              key={index}
                              onClick={() => History.push(c?.path)}
                              active={splitLocation[1] === c?.isActive}
                            >
                              {c?.title}
                            </NavDropdown.Item>
                          );
                        })}
                      </NavDropdown>
                    </Nav>
                  )}
                </li>
              ) : null;
            }
          }

          return link;
        })}
      </ul>
    </div>
  );
};

export default MenuMaster;
